import React, { useContext } from 'react';
import { Row, Col, Stack, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import 'Pages/Doctor/DoctorDashboard/doctorDashboard.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage } from 'react-intl';
import ArrowRightIcon from 'assets/images/Dashboard/arrow-right-detail.svg';
import MailIcon from 'assets/images/Dashboard/mail.svg';
import CallIcon from 'assets/images/Dashboard/call.svg';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { doctorPatientDetails } from 'routes/AppUrls';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import Loader from 'components/commom/Loader';
import {
  basicDetailsValue,
  PATIENT_ID,
} from 'store/BasicDetailValues/BasicDetailValuesAction';

const DashoardPatientList = () => {
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();

  const loading = useSelector((state) => state?.getDashboardReducer?.loading);

  const dashboardDetail = useSelector(
    (state) => state?.getDashboardReducer?.users?.data
  );

  const handleNaigatePatient = (id) => {
    navigate(doctorPatientDetails(locale, id));
    dispatch(basicDetailsValue(PATIENT_ID, id));
  };

  return (
    <div>
      <Row className="mt-4 pt-1">
        <Col sm={12} md={12} className="flex justify-between">
          <div className="fs-20 fc-292D32 family_outfit_bold_700">
            <FormattedMessage id="Recent Patients" />
          </div>
        </Col>
      </Row>

      {loading ? (
        <Loader marginTop={'20vh'} />
      ) : dashboardDetail?.patient_list &&
        dashboardDetail?.patient_list.length > 0 ? (
        <>
          <Row className="mt-3 listCustomHeader m-0 p-0 flex items-center">
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600">
                <FormattedMessage id="Patient & ID" />
              </p>
            </Col>

            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600">
                <FormattedMessage id="Contact Info" />
              </p>
            </Col>

            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600">
                <FormattedMessage id="Last Appointment" />
              </p>
            </Col>

            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600">
                <FormattedMessage id="Actions" />
              </p>
            </Col>
          </Row>

          <Row className="bc-FFFFFF m-0 p-0">
            {dashboardDetail?.patient_list.map((item, index) => {
              return (
                <Row className="m-0 p-0 flex items-center listAppointment">
                  <Col lg={3} md={6} sm={12}>
                    <div className="p-0 m-0 fs-14 fc-202224 lh-176 family_outfit_semiBold_600">
                      {item?.patient_name}
                    </div>
                    <div className="fs-12 fc-202224 family_outfit_regular_400 pt-04 lh-1512">
                      {item?.patient_id}
                    </div>
                  </Col>

                  <Col lg={3} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center "
                    >
                      <Image src={MailIcon} alt="icon" />
                      <div className="p-0 m-0 fs-14 fc-202224 lh-176 family_outfit_regular_400 break-all ...">
                        {item?.patient_email}
                      </div>
                    </Stack>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center mt-2"
                    >
                      <Image src={CallIcon} alt="icon" />
                      <div className="p-0 m-0 fs-14 lh-176 fc-202224 family_outfit_regular_400">
                        {`${item?.patient_phone}`}
                      </div>
                    </Stack>
                  </Col>

                  <Col lg={3} md={6} sm={12}>
                    <div className="p-0 m-0 fs-14 lh-176 fc-202224 family_outfit_regular_400">
                      {moment(item?.consulted_on).format('DD MMM YYYY')}
                    </div>
                  </Col>

                  <Col lg={3} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center cursor-pointer"
                      onClick={() => handleNaigatePatient(item?.id)}
                    >
                      <div className="fs-16 fc-C56616 family_outfit_medium_500 cursor-pointer">
                        <FormattedMessage id="View Details" />
                      </div>
                      <Image src={ArrowRightIcon} alt="icon" />
                    </Stack>
                  </Col>
                </Row>
              );
            })}
          </Row>
        </>
      ) : (
        <div className="flex justify-center pt-40">
          <div>
            <Image src={EmptyScreen} alt="icon" />
            <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
              Nothing here yet
            </div>
            <div className="fs-16 fc-998A7B lh-16 family_outfit_regular_400  text-center pt-8">
              No appointments have been booked
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashoardPatientList;
